import { role } from "./roles.mjs";

export const permissions = {
  operations: {
    medicalReportRequest: new Set([
      role.Manager_Customer_Care,
      role.Manager_Clinic,
    ]),
  },
};
